import i18n from "i18next";
import { isValidPhoneNumber } from "react-phone-number-input";

export const isValidPhone = function (number, setErrorForm) {
  let errorNumber = true;
  if (number !== "") {
    if (!isValidPhoneNumber(number)) {
      errorNumber = false;
      setErrorForm(i18n.t("settingsUsers.invalidPhoneNumber", { number }));
    }
  }

  return errorNumber;
};
